import { createImageUrlBuilder, SanityImageSource } from "@sanity/image-url";
import { sanityClient } from "./client";

// https://www.sanity.io/docs/image-url
const builder = createImageUrlBuilder(sanityClient);

export const urlFor = (source: SanityImageSource & { _dataset?: string }) => {
  const datasetOverride = source._dataset;
  return builder
    .image(source)
    .dataset(datasetOverride || sanityClient.config().dataset!);
};
